import React from 'react';
import PropTypes from 'prop-types';

const LoadingSpinner = ({ loading }) => {
  return loading ? (
    <>
      <style>
        {`
          .spinner-overlay {
            position: fixed;
            inset: 0;
            background: rgb(32 24 24 / 70%);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10000;
          }

          .spinner {
            border: 16px solid #f3f3f3;
            border-top: 16px solid var(--focus);
            border-radius: 50%;
            width: 120px;
            height: 120px;
            animation: spin 2s linear infinite;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="spinner-overlay">
        <div className="spinner"></div>
      </div>
    </>
  ) : null;
};

LoadingSpinner.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default LoadingSpinner;
